import { ComponentProps, ComponentType, FunctionComponent } from 'react';
import connect, { WithFormsProps } from './withForms.state';

export const withForms = <TProps extends {}>(Component: ComponentType<TProps>) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const WrappedComponent = connect(Component as any);

  WrappedComponent.displayName = `WithForms(${WrappedComponent.displayName ||
    'Component'})`;

  return WrappedComponent as FunctionComponent<
    Omit<ComponentProps<typeof Component>, keyof WithFormsProps>
  >;
};
